import { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/feature/SEO';

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

function getCategoryDescription(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.description : '';
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [active, setActive] = useState(slug || 'dongzuo');

  const filteredMovies = useMemo(
    () => movies.filter((m) => m.category === active),
    [active]
  );

  const categoryName = getCategoryName(active);
  const categoryDesc = getCategoryDescription(active);

  return (
    <>
      <SEO
        title={`97影视${categoryName} - 最新${categoryName}高清免费在线观看`}
        description={`97影视${categoryName}频道，${categoryDesc}海量${categoryName}资源，高清流畅播放，免费在线观看。`}
        keywords={`97影视,${categoryName},${categoryName}电影,高清${categoryName},在线看${categoryName},免费${categoryName}`}
        canonical={`https://www.97yingshi.com/category/${active}`}
        ogTitle={`97影视${categoryName} - 最新${categoryName}高清免费在线观看`}
        ogDescription={`97影视${categoryName}频道，${categoryDesc}`}
        ogUrl={`https://www.97yingshi.com/category/${active}`}
        ogType="website"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: `97影视${categoryName}`,
          description: categoryDesc,
          url: `https://www.97yingshi.com/category/${active}`,
        }}
      />

      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: categoryName },
        ]}
      />

      <main className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
            97影视{categoryName}
          </h1>
          <p className="text-sm text-foreground-500 mt-1">{categoryDesc}</p>
        </div>

        <div className="flex items-center gap-1.5 mb-6 overflow-x-auto pb-2 flex-nowrap">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActive(cat.slug)}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-950'
                  : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-xs`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        {filteredMovies.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {filteredMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
              <i className="ri-film-line text-2xl text-foreground-500"></i>
            </div>
            <p className="text-foreground-500">该分类暂无电影</p>
          </div>
        )}
      </main>
    </>
  );
}